module.exports = __webpack_public_path__ + "atul-3f70d84e419f3ed96adb.jpg";